export default __webpack_public_path__ + "static/media/me.5baa24c0.jpg";